/**
 *   Created by Arif Topcu in 2018
 */
import React from "react";
import PropTypes from "prop-types";
import Combobox from "@ls/react-combobox-grid";
import Button from "@ls/react-button";
import SelectionState from "state/selections/SelectionState";
import { useDispatch, useSelector } from "react-redux";
import {
  newGroupingLevelsFilter,
  setSelectedGroupingLevels,
} from "state/selections/actions";
import {
  selectSelectedGroupingLevels,
  selectSelectedGroupingLevelsFilters,
  selectSelectedGroupingLevelsFiltersReweight,
} from "state/selections/selectors";
import {
  selectFetchingGroupingLevels,
  selectGroupingLevelOptions,
} from "state/data/selectors";
import Filter from "./Filter";
import { card } from "components/Card";
import styled from "styled-components";
import Icon from "react-icons-kit";
import { ic_add } from "react-icons-kit/md/ic_add";
import Checkbox from "@ls/react-checkbox";
import { setGroupingLevelFilterReweight } from "state/selections/actions";
const Card = styled.div`
  ${card}
  background: rgba(208, 208, 208, 0.75);
  padding: 5px;
`;
const ColoredIcon = styled(Icon)`
  color: ${({ theme }) => theme.primaryColor};
`;

const LevelSelector = (props) => {
  const dispatch = useDispatch();
  const fetchingGroupingLevels = useSelector(selectFetchingGroupingLevels);
  const selectedGroupingLevels = useSelector(
    selectSelectedGroupingLevels(SelectionState.UNCOMMITTED)
  );
  const selectedGroupingLevelsFilters = useSelector(
    selectSelectedGroupingLevelsFilters(SelectionState.UNCOMMITTED)
  );
  const groupingLevelReweight = useSelector(
    selectSelectedGroupingLevelsFiltersReweight(SelectionState.UNCOMMITTED)
  );

  const [addFilterDisabled, addFilterTooltip] = React.useMemo(() => {
    if (!selectedGroupingLevels?.length) {
      return [true, "Missing grouping levels."];
    }
    return [];
  }, [selectedGroupingLevels?.length]);

  const onChange = React.useCallback(
    (groupingLevels) => {
      dispatch(setSelectedGroupingLevels(groupingLevels));
    },
    [dispatch]
  );

  const options = useSelector(selectGroupingLevelOptions);

  const value = useSelector(
    selectSelectedGroupingLevels(SelectionState.UNCOMMITTED)
  );

  const onAddFilter = React.useCallback(() => {
    dispatch(newGroupingLevelsFilter());
  }, [dispatch]);
  const onChangeReweight = React.useCallback(
    (value) => {
      dispatch(setGroupingLevelFilterReweight(value));
    },
    [dispatch]
  );

  return (
    <Card>
      <Combobox
        options={options}
        onChange={onChange}
        value={value}
        loading={fetchingGroupingLevels}
        placeholder="Bucket Levels..."
        clearable={true}
        multi
        label="Bucket Levels:"
        enableSpeedDial
        persistKey="COMBOBOX_BUCKETS"
      />
      <Button
        label="Add Bucket Level Filter"
        variation={6}
        icon={<ColoredIcon icon={ic_add} />}
        onButtonClick={onAddFilter}
        disabled={addFilterDisabled}
        tooltip={addFilterTooltip}
      />
      {selectedGroupingLevelsFilters.map((groupingLevelFilter, idx) => (
        <Filter groupingLevelFilter={groupingLevelFilter} key={idx} idx={idx} />
      ))}
      {selectedGroupingLevelsFilters.length > 0 && (
        <Checkbox
          onChange={onChangeReweight}
          value={groupingLevelReweight}
          label="Re-Weight Remaining Buckets"
        />
      )}
    </Card>
  );
};

LevelSelector.propsTypes = {
  groupingLevels: PropTypes.array.isRequired,
  selectedGroupingLevelValues: PropTypes.array,
  loading: PropTypes.bool.isRequired,
  setSelectedGroupingLevels: PropTypes.object,
};

export default LevelSelector;
